module.exports = __webpack_public_path__ + "img/press-lg@2x.0cc16a0.png";